import { RootElement } from "./RootElement";

export default RootElement;
